/**
 * Calcoli di prezzo di "Analisi prezzi" eBay, condivisi fra tabella e dialog.
 *
 * Su eBay non c'e' la buybox: si confronta il nostro totale (prezzo + spedizione,
 * come lo vede il cliente) con quello del concorrente piu' economico trovato per EAN.
 * Stessa regola di features/ebayprice/browse.parser.js suggestedPrice.
 */

const toNumber = value => {
	if (value === undefined || value === null || value === '') {
		return null;
	}
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : null;
};

const round2 = value => Math.round(value * 100) / 100;

/** nostra spedizione letta dall'ultima ricerca (la nostra inserzione compare fra i risultati) */
export const ourShipping = item => {
	const analysis = (item && item.analysis) || {};
	return analysis.ourFound ? toNumber(analysis.ourShipping) : null;
};

/** nostro totale con il prezzo attuale (anche dopo un aggiustamento) */
export const ourTotal = item => {
	const price = toNumber(item && item.price);
	const shipping = ourShipping(item);
	if (price === null) {
		return null;
	}
	return shipping === null ? null : round2(price + shipping);
};

/** c'e' un concorrente con un totale piu' basso del nostro */
export const isBeaten = item => {
	const analysis = (item && item.analysis) || {};
	const total = ourTotal(item);
	const competitor = toNumber(analysis.competitorTotal);
	return analysis.status === 'done' && total !== null && competitor !== null && total > competitor;
};

/** Prezzo proposto: il nostro totale un centesimo sotto quello del concorrente. */
export const suggestedPrice = item => {
	const analysis = (item && item.analysis) || {};
	const competitorTotal = toNumber(analysis.competitorTotal);
	const competitorPrice = toNumber(analysis.competitorPrice);
	const shipping = ourShipping(item);

	let value = null;
	if (competitorTotal !== null && shipping !== null) {
		value = round2(competitorTotal - shipping - 0.01);
	} else if (competitorPrice !== null) {
		value = round2(competitorPrice - 0.01);
	}
	return value !== null && value > 0 ? value : null;
};
